import React, {Component} from 'react';
import {connect} from 'react-redux';

import Box from 'components/box';
import Input from 'form/input';
import Textarea from 'form/textarea';
import styled from 'styled-components'
import Spinner from 'spinner';
import Upload from 'components/upload'
import {Link} from 'react-router-dom';
import Breadcrumbs from 'components/breadcrumbs';
import {PageHead} from 'components/header/components';
import {ButtonDefault} from 'components/buttons';
import {Divider, Select, Label} from 'components/common';
import CKEditor from 'react-ckeditor-wrapper';

import ReactModal from 'react-modal';
import {Modal, CloseModal, ModalContent} from 'components/modal';
import {ButtonSuccessModal, ButtonDangerModal, ButtonWrap} from 'components/buttons';
import close from 'images/general/close.svg';

import {submitNews, loadNewsDetail, loadTagsByNewsDetail, newsCleanFiles, loadContentByNews, changeNewsItemValue, attachFileToNews, newsCleanStore, loadNewsTags, addTitleImageToNews} from 'redux/actions/portal/news';

const UploadWrapper = styled.div`
  margin-top: 10px;
  margin-bottom: 10px;
`

const mapStateToProps = state => ({
  detail: state.news.get('newsDetail'),
  isSubmitting: state.news.get('newIsSubmitting'),

  isLoading: state.news.get('newsAreLoading'),
  content: state.news.get('newsContent'),
  contentAreLoading: state.news.get('contentByNewsIsLoading'),

  item: state.news.get('newsItem'),
  attach: state.news.get('attachedFiles'),
  
  allTags: state.news.get('newsTags'),
  allNewsTagsAreLoading: state.news.get('allNewsTagsAreLoading'),
 
  tagsByNews: state.news.get('tagsByNews'),
  tagsByNewsAreLoading: state.news.get('tagsByNewsAreLoading'),

  user: state.auth.get('user')
});

const mapDispatchToProps = dispatch => ({
  onLoad: (id) => {
    dispatch(loadNewsDetail(id))
    dispatch(loadTagsByNewsDetail(id))
    dispatch(loadContentByNews(id))
  },
  loadAllTags: () =>  dispatch(loadNewsTags()),

  onSubmit: (id, event, author_id, tag_id, current_status) => {
    event.preventDefault()
    dispatch(submitNews(id, author_id, tag_id, current_status))
  },
  onAddFiles: (event) => {
    event.preventDefault()
    dispatch(attachFileToNews(event.target));
	},
  onTitleImageChange: file => dispatch(addTitleImageToNews(file)),
  onClean: () => {
    dispatch(newsCleanStore())
    dispatch(newsCleanFiles())
  },
  onValueChange: (value, key) => dispatch(changeNewsItemValue(value, key)),
});

class CreateNews extends Component {

  constructor(props) {
    super(props);

    this.state = {
      tag: "",
      currentStatus: "draft",
      modalOpen: false
    }
    this.onTagChange = this.onTagChange.bind(this);
    this.onStatusChange = this.onStatusChange.bind(this);
  }

  onTagChange(event) {
    if (this.state.tag !== event.target.value){
      this.setState({ tag: event.target.value })
    } else {
      this.setState({ tag: null })
    }
    this.props.onValueChange(event.target.value, ['tag_list', 0, 'tag_data', 'id']);
  }

  onStatusChange(event){
    this.setState({ currentStatus: event.target.value })
  }

  toggleModal = () => this.setState(prevState => ({modalOpen: !prevState.modalOpen}))

  onModalOk = () => {
    this.toggleModal()
    this.props.history.goBack()
  }

  componentDidMount() {
    if (this.props.match.params.id !== undefined) {
      this.props.onLoad(this.props.match.params.id)
      this.props.loadAllTags()
    } else {
      this.props.onClean();
      this.props.loadAllTags()
    }
  }

  componentWillUnmount(){
    this.props.onClean();
  }

  render() {

    if (this.props.isLoading || this.props.isSubmitting) return <Spinner/>;

    if (this.props.match.params.id && !this.props.content) return <Spinner/>;

    if (this.props.match.params.id && this.props.tagsByNewsAreLoading) return <Spinner/>;

    if (this.props.allNewsTagsAreLoading) return <Spinner/>;

    return (
      <div>
          <Breadcrumbs>
              <li><Link to="/admin/">Головна</Link></li>
              {this.props.match.params.id ? (
                  <li><Link to={`/admin/news/detail/${this.props.match.params.id}/edit`}>Редагування новини {this.props.detail.get('id')}</Link></li>
              ):(
                  <li><Link to="/admin/news/create">Створити новину</Link></li>
              )}
          </Breadcrumbs>
         <PageHead>
          <h2>{this.props.match.params.id ? "Редагувати новину" : "Cтворити новину"}</h2>
        </PageHead>
        <Box title4={this.props.match.params.id ? "Форма редагування новини" : "Форма створення новини"}>
          <form onSubmit={(event) => this.props.onSubmit(this.props.match.params.id, event, this.props.user.get('id'), this.state.tag, 'public')}>
          
            <Input
              block
              label="Заголовок новини:"
              required
              max="128"
              placeholder="Введіть заголовок новини"
              value={this.props.detail ? this.props.detail.get('title') : ""}
              onChange={(event) => this.props.onValueChange(event.target.value, 'title')}
            />
            <Textarea
              block
              required
              max="512"
              label="Короткий опис новини: "
              placeholder="Введіть короткий опис новини"
              value={this.props.detail ? this.props.detail.get('brief_description') : ""}
              onChange={(event) => this.props.onValueChange(event.target.value, 'brief_description')}
            />
            <Label style={{marginBottom: "5px"}}>Опис новини:<span style={{color: "#edbd2f"}}> *</span></Label>
            <CKEditor
              value={this.props.detail ? this.props.detail.get('detail_description') : ""}
              onChange={(value) => this.props.onValueChange(value, 'detail_description')}
            />  

              {this.props.match.params.id && this.props.detail.get('tag_list').get(0) !== undefined ? (
                <Divider>
                <Label>Тег новини:<span style={{color: "#edbd2f"}}> *</span></Label>
                <Select value={this.props.detail.get('tag_list').get(0).get('tag_data').get('id')} onChange={this.onTagChange}>
                {/* <option selected >{this.props.detail.get('tag_list').get(0).get('tag_data').get('title')}</option> */}
                  {this.props.allTags.get('results').map((item, i) => (
                    <option key={item.get('id')} value={item.get('id')}>{item.get('title')}</option>
                  ))}
                </Select>
              </Divider>
              ): (
                <Divider>
                <Label>Тег новини:<span style={{color: "#edbd2f"}}> *</span></Label>
               <Select value={this.state.tag} onChange={this.onTagChange}>
                {this.props.allTags.get('results').map(item => (
                  <option key={item.get('id')} value={item.get('id')}>{item.get('title')}</option>
                ))}
                </Select>
              </Divider>
              )}


              <UploadWrapper>
              <Upload
                loadImage 
                label="Головне зображення новини"
                accept=".png, .jpg, .jpeg, .gif"
                onChange={this.props.onTitleImageChange}
                file={this.props.detail ? this.props.detail.get('image'): ""}
              />
              </UploadWrapper>


              <Divider>
               <Input
                 type="file"
                 multiple={true}
                 label="Прикріпити фотографії"
                 accept=".png, .jpg, .jpeg, .gif"
                 onChange={(event) => this.props.onAddFiles(event)}
               />
             </Divider> 


            <Divider>
              <ButtonDefault type="submit" value="Опублікувати"/>
              <ButtonDefault value="Зберегти до чернеток" onClick={(event) => this.props.onSubmit(this.props.match.params.id, event, this.props.user.get('id'), this.state.tag, 'draft')}/>
              <ButtonDefault onClick={this.toggleModal} value="Вийти без збереження"/>
            </Divider>
          </form>
        </Box>

        <ReactModal isOpen={this.state.modalOpen} onRequestClose={this.toggleModal}
                    className={{
                      base: 'modalContent',
                      afterOpen: 'myClass_after-open',
                      beforeClose: 'myClass_before-close'
                    }} contentLabel="Підтвердження запису"
                    overlayClassName={{
                      base: 'modalOverlay',
                      afterOpen: 'myOverlayClass_after-open',
                      beforeClose: 'myOverlayClass_before-close'
                    }}>
          <div>
            <Modal>
              <CloseModal>
                <div>
                  <img src={close} alt="закрити" onClick={this.toggleModal} />
                </div>
              </CloseModal>

              <ModalContent>
                <h3>
                  Ви впевнені, що хочете вийти без збереження?
                  Всі внесені зміни будуть скасовані
                </h3>
                <ButtonWrap>
                  <ButtonSuccessModal onClick={this.onModalOk} value="Так"/>
                  <ButtonDangerModal value="Ні" onClick={this.toggleModal}/>
                </ButtonWrap>
              </ModalContent>

            </Modal>
          </div>
        </ReactModal>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateNews);



// WEBPACK FOOTER //
// ./src/admin/news/create.js